import React from 'react'
import Herodentalseo from '../components/digital marketing/dentalseo/herodental'
import Aboutdental from '../components/digital marketing/dentalseo/aboutdentalseo'
import Alice from '../components/alicecarousel'
import Whydentistseo from '../components/digital marketing/dentalseo/whydental'
import Modal1 from '../components/modal'
import Whyyouneed1 from '../components/digital marketing/whyyouneed'
import Form1 from '../components/herosection/form'

function Dentalseo() {
    return (
        <div>
            <Herodentalseo />
            <Aboutdental />
            <Alice />
            <Whydentistseo />
            <Whyyouneed1 />
            <Form1 />
        </div>
    )
}

export default Dentalseo